<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">报考专业</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="pcList" text-field="mc" @change="changePc" value-field="id" v-model="query.pcId" placeholder="-报考专业筛选-"  :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--试卷名称-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label id="sjmc" class="col-sm-3 control-label">试卷名称</label>
                            <div class="col-sm-9">
                                <input type="text" name="sjmc" v-model="query.sjmcWord" class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                    <!--状态-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">状态</label>
                            <div class="col-sm-9">
                                <select name="sjzt" v-model="query.sjzt" class="form-control"
                                        v-validate="{required:true,max:50}" data-vv-as="状态">
                                    <option value="">-请选择-</option>
                                    <option value="ZCKY">正常可用</option>
                                    <option value="BKY">不可用</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div class="col-sm-12">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-right:2px"><i class="fa fa-search" aria-hidden="true"></i>查询
                            </button>
                            <button @click="addsj()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 2px"><i class="fa fa-plus" aria-hidden="true"></i>创建试卷
                            </button>
                            <button @click="plsz()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 2px"><i class="fa fa-tag" aria-hidden="true"></i>批量设置考试属性
                            </button>
                            <button @click="qcyzm()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 2px"><i class="fa fa-eraser" aria-hidden="true"></i>清除验证码
                            </button>
                            <button @click="plkl()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 2px"><i class="fa fa-files-o" aria-hidden="true"></i>批量克隆试卷
                            </button>
                            <button @click="fpyjls()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 2px"><i class="fa fa-user" aria-hidden="true"></i>分配阅卷老师
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<ExamPapershuxing ref="ExamPapershuxing"></ExamPapershuxing>
		<ExamPaperClone ref="ExamPaperClone"></ExamPaperClone>
		<ExamPaperPlsz ref="ExamPaperPlsz"></ExamPaperPlsz>
		<ExamPaperPlkl ref="ExamPaperPlkl"></ExamPaperPlkl>
		<ExamPaperFpyjls ref="ExamPaperFpyjls"></ExamPaperFpyjls>
    </div>
</template>
<script>
    /**
     * 试卷管理-综合测验
     */
    import tableMixin from '@/mixins/table.js';  //表格
    import ExamPapershuxing from './ExamPapershuxing.vue';   //查看
    import ExamPaperClone from './ExamPaperClone.vue';   //克隆
    import ExamPaperPlsz from './ExamPaperPlsz.vue';   //批量设置
    import ExamPaperPlkl from './ExamPaperPlkl.vue';   //批量克隆
    import ExamPaperFpyjls from './ExamPaperFpyjls.vue';   //批量克隆

    export default {
        mixins: [tableMixin],
        name: "ExamPaperList",
        components :{
			ExamPapershuxing,
			ExamPaperClone,
			ExamPaperPlsz,
			ExamPaperPlkl,
			ExamPaperFpyjls
        },
        data: function () {
            return {
                pcList: [],
                kcList: [],
                ztList: [],
                query: {
                    pcId: '',  //培训项目
                    kcId: '', //课程
                    sjzt: '', //试卷状态
                    sjmcWord: ''//试卷名称

                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'pcmc',
                        title: '报考专业',
                        formatter: (value, row) => {
                            return row.xmbh + '-' + value;
                        }
                    },
					{
					    field: 'sjmc',
					    title: '作业名称'
					},
                    {
                        field: 'kcmc',
                        title: '课程',
                    },
                    {
                        field: 'sjzt',
                        title: '开放状态',
                        formatter: (value) => {
                            return value == 'ZCKY' ? '正常可用' : '不可用';
                        }
                    },
                    {
                        field: 'sjsd',
                        title: '时间设定',
                        formatter: (value, row) => {
                            if (row.kksj && row.jssj) {
                                //后台返回的有秒  截取0到16
                                return row.kksj.substring(0, 16) + "<br />" + row.jssj.substring(0, 16);
                            }
                            return '';
                        }
                    },
                    {
                        field: 'jmzf',
                        title: '卷面总分'
                    },
                    {
                        field: 'ksrs',
                        title: '考试人数'
                    },
					{
					    field: 'cjsj',
					    title: '创建时间',
					},
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template:
                                    '<div class="operation_column"><a  @click="pz(row)">配置</a> | ' +
                                    '<a @click="edit(row)">修改</a> | ' +
                                    '' + '<a @click="testXq(row)">考试详情</a> | ' +
                                    '<a @click="view(row)">预览</a> | ' +
                                    '<a @click="check(row)">查看</a> | ' +
                                  /*  '<button class="btn btn-xs btn-primary" @click="dcWord(row)">导出Word</button>&nbsp;&nbsp;' +*/
                                    '<a @click="klsj(row)">克隆试卷</a> | ' +
                                    '<a @click="sc(row)">删除</a>' +
                                    '</div>',
                                data: {row},
                                methods: {
                                    pz: this.pz,
                                    edit: this.edit,
                                    testXq: this.testXq,
                                    view: this.view,
                                    check: this.check,
                                    dcWord: this.dcWord,
                                    klsj: this.klsj,
                                    sc: this.sc

                                }
                            })
                        }
                    }

                ]
            }
        },
       mounted(){
       	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
       	this.load();
       },
       beforeRouteUpdate(to, from, next){
		this.query = Object.assign(this.query,{current:1,size:10},to.query);
       	this.load();
       	next();
       },
        created: function () {
            this.$store.commit('setBreadcrumb', [ {name: '自学考试'}, {name: '日常练习管理'}, {name: '综合测验'}]);
            this.ztList = [{value: 'KF', text: '开放'}, {value: 'GB', text: '关闭'}, {value: 'CG', text: '草稿'}];//状态
            this.getpcList();//获取培训项目列表
        },
        methods: {
            //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/sj/zhcy/hqpc').then(res => {
                    this.pcList = res.data;
                });
            },
			showKcOption:function(item){
				return item.kcdm+"-"+item.kcmc;
			},
			changePc:function(){
				this.query.kcId = '';
				if (this.query.pcId) {
					this.$http.post("/htgl/biz/zypx/sj/zhcy/hqkc", {pcId: this.query.pcId}).then(res => {
						this.kcList = res.data;
					});
				}
				else {
					this.kcList = [];
				}
			},
            //创建试卷
            addsj: function () {
                this.$router.push({name: 'ExamPaperAdd'});
            },
            //配置
            pz: function (row) {
                if(row.sjlx === 'PT' || row.sjlx ==='SJ'){
                    this.$router.push({name: 'ExamPaperPeizhi', query: {paper_id: row.id}});
                }else {
                    this.$router.push({name: 'ExamPaperZdzj', query: {id: row.id, kcId: row.kcid, sjfl: row.sjfl, sjmc:row.sjmc, kcmc: row.kcmc }});
                }
            },
            //删除
            sc: function (row) {
                this.$confirm('确定执行此操作吗', () => {
                    this.$http.post("/htgl/biz/zypx/sj/zhcy/sc", {id: row.id}).then((res) => {
                        if (res.data == true) {
                            this.$success('操作成功', () => {
                                this.search();//刷新列表
                            });
                        }
                    });
                });
            },
            //修改
            edit: function (row) {
                this.$router.push({name: 'ExamPaperEdit', query: {id: row.id}})
            },
            //考试详情
            testXq: function (row) {
                this.$router.push({name: 'ExamYzRecordList',query: {id: row.id}});
            },
            //试卷详情 题干解析...
            view: function (row) {
                if (row.sjlx === 'MB') {
                    this.$error("模板不支持预览！");
                    return false
                }
                this.$router.push({name: 'ExamPaperView', query: {id: row.id}});
            },
            //查看
            check: function (row) {
				this.$refs.ExamPapershuxing.open({ id: row.id});
            },
            //导出word
            dcWord: function (row) {
                this.$http.post("/htgl/biz/zypx/sj/zhcy/dcword", {id: row.id}).then((res) => {
                    this.$success("导出试卷成功");
                });
            },
            //克隆试卷
            klsj: function (row) {
				this.$refs.ExamPaperClone.open({id: row.id});
            },
            //批量设置考试属性
            plsz: function () {
                let selections = this.$refs.table.getSelections();
                let ids = [];  //注册ids
                ids = selections.map(x => {
                    return x.id
                });
                ids = ids.join(",");
                if (ids.length > 0) { //如果有勾选项批量设置
					this.$refs.ExamPaperPlsz.open({ ids: ids});
                } else {
                    this.$error('请选择一条数据记录');
                }
            },
            //清除验证码
            qcyzm: function () {
                let selections = this.$refs.table.getSelections();
                let ids = [];  //ids
                ids = selections.map(x => {
                    return x.id
                });
                ids = ids.join(",");
                if (ids.length > 0) { //如果有勾选项批量设置
 					this.$http.post('/htgl/biz/zypx/sj/zhcy/qcyzm', {ids: ids}).then(res => {
	                    if (res.data == true) {
                            this.$success('操作成功', () => {
                                this.search();//刷新列表
                            });
                        }
                	});
                } else {
                    this.$error('请选择一条数据记');
                }
            },
            //分配阅卷老师
            fpyjls: function () {
                let selections = this.$refs.table.getSelections();
                let ids = [];  //注册ids
                ids = selections.map(x => {
                    return x.id
                });
                ids = ids.join(",");
                if (ids.length > 0) { //如果有勾选项批量设置
					this.$refs.ExamPaperFpyjls.open({ids: ids});
                } else {
                    this.$error('请选择一条数据记录');
                }
            },
            //批量克隆
            plkl: function () {
                let selections = this.$refs.table.getSelections();
                let ids = [];  //注册ids
                ids = selections.map(x => {
                    return x.id
                });
                ids = ids.join(",");
                if (ids.length > 0) { //如果有勾选项批量设置
					this.$refs.ExamPaperPlkl.open({ids: ids});
                } else {
                    this.$error('请选择一条数据记录');
                }
            },
            search: function () {
               //将数据表格的页码以及每一页展示的数据重置为1，10
               let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            },
            load: function (pageNumber, pageSize) {
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/sj/zhcy/cx', this.query).then(res => {
                    let data = res.data;
                    //封装返回值
                    let result = {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange: function (pageNumber, pageSize) {
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
